import { Footer } from '../Footer'

import { type ReactNode } from 'react'
import Header from '../Header'
import CookieBanner from '../Cookie'
import classNames from 'classnames'

type LayoutProps = {
  headerHasDarkBg?: boolean
  isFlatHeader?: boolean
  headerBgColor?: string
  headerScrollable?: boolean
  eventsHeader?: boolean
  children: ReactNode
  style?: Record<string, string | number>
  className?: string
  css?: Record<string, string | number>
}

const Structure = ({
  children,
  headerHasDarkBg,
  isFlatHeader,
  headerBgColor,
  headerScrollable,
  eventsHeader = false,
}: LayoutProps) => {
  return (
    <>
      <div className="bg-white rounded-b-3xl xl:rounded-b-[40px]">
        <Header
          isDarkBg={headerHasDarkBg}
          isFlatHeader={isFlatHeader}
          bgColor={headerBgColor}
          headerScrollable={headerScrollable}
          eventsHeader={eventsHeader}
        />

        {children}
      </div>
      <Footer />
      <CookieBanner />
    </>
  )
}

const Content = ({ children, headerHasDarkBg, style, className }: LayoutProps) => {
  return (
    <div
      className={classNames(
        'bg-white text-neutral-100 layout-content rounded-br-[40px] rounded-bl-[40px] max-xl:max-w-[1400px] xl:mx-auto',
        {
          'text-white': !!headerHasDarkBg,
        },
        className,
      )}
      style={style}
    >
      {children}
    </div>
  )
}

export const Layout = Object.assign(Structure, {
  Content: Content,
})
